import { h, Component } from "preact";
import Ticket from "./ticket";

/**
 * Interfaccia per la struttura dei dati scambiati tramite postMessage
 */
export interface IframeMessageData {
    msg: string;
    data?: any;
}

export default class IframeMessages extends Component<{}, {}> {
    // Riferimento alla funzione listener per poterla rimuovere correttamente
    private msgListener: (e: MessageEvent) => void;

    constructor() {
        super();
        // Bindiamo il listener nel costruttore
        this.msgListener = (e: MessageEvent) => this.dispatch(e);
    }

    componentDidMount() {
        window.addEventListener('message', this.msgListener);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.msgListener);
    }

    render() {
        return null;
    }

    /**
     * Gestisce i messaggi in entrata dall'iframe parent o da altre finestre
     */
    private dispatch(e: MessageEvent<IframeMessageData>): void {
        // Controllo di sicurezza sulla struttura del messaggio
        if (!e.data || typeof e.data !== 'object' || !e.data.msg) {
            return;
        }

        switch (e.data.msg) {
            case "softion.navigation.cart":
                IframeMessages.onCartNavigation();
                break;
            case "softion.navigation.sport":
                IframeMessages.onSportNavigation();
                break;
        }
    }

    /**
     * Invia un messaggio al parent per aggiornare il numero di quote nel carrello
     * @param numOdds Numero attuale di quote
     */
    static setTicketOddsNum(numOdds: number): void {
        try {
            // Verifica che esista un parent e che non sia la finestra stessa
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({ 
                    msg: 'softion.cart.numOdds', 
                    data: numOdds 
                }, '*');
            }
        } catch (e) {
            // Silenzioso come l'originale per evitare errori cross-origin non gestiti
        }
    }

    /**
     * Metodo placeholder da sovrascrivere per gestire la navigazione verso il carrello.
     * @override
     */
    static onCartNavigation(): void {}

    /**
     * Metodo placeholder da sovrascrivere per gestire la navigazione verso lo sport.
     * @override
     */
    static onSportNavigation(): void {}
}

/**
 * Sottoscrizione agli aggiornamenti delle quote del Ticket.
 * Ogni volta che il carrello cambia, notifica il parent tramite requestAnimationFrame.
 */
Ticket.subscribeOddsUpdates(() => {
    requestAnimationFrame(() => {
        IframeMessages.setTicketOddsNum(Ticket.countOdds());
    });
});